/*
 *
 * ActivityReviewsPage reducer
 *
 */

import produce from 'immer';
import { ActionTypes } from './actions';

export const key = 'activityReviewsPage';
export const initialState = {
    is404: false,
    page: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        res: null,
    },
    reviews: {
        errorMessage: '',
        isError: false,
        isLoaded: false,
        isLoading: false,
        hasMore: false,
        res: [],
    },
    params: {
        id: '',
        slug: '',
        search: '',
    },
};

/* eslint-disable no-param-reassign, default-case */
function activityReviewsPageReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            // Common
            case ActionTypes.SET_PARAMS:
                draft.params = action.params;
                return draft;
            case ActionTypes.SET_IS_404:
                draft.is404 = action.is404;
                return draft;
            case ActionTypes.RESET_CONTENTS:
                draft.is404 = initialState.is404;
                draft.page = initialState.page;
                draft.reviews = initialState.reviews;
                return draft;
            // Page
            case ActionTypes.FETCH_PAGE_STARTED:
                draft.page.isLoading = true;
                draft.page.isError = false;
                draft.page.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_PAGE_SUCCESSFULLY:
                draft.page.isLoading = false;
                draft.page.isLoaded = true;
                draft.page.res = action.res;
                return draft;
            case ActionTypes.FETCH_PAGE_FAILED:
                draft.page.isLoading = false;
                draft.page.isError = true;
                draft.page.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_PAGE_CANCELLED:
                draft.page.isLoading = false;
                return draft;
            case ActionTypes.SET_PAGE_IS_LOADED:
                draft.page.isLoaded = action.isLoaded;
                return draft;
            // Reviews
            case ActionTypes.FETCH_REVIEWS_STARTED:
                draft.reviews.isLoading = true;
                draft.reviews.isError = false;
                draft.reviews.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_REVIEWS_SUCCESSFULLY:
                draft.reviews.isLoading = false;
                draft.reviews.isLoaded = true;
                draft.reviews.res = action.res;
                return draft;
            case ActionTypes.FETCH_REVIEWS_FAILED:
                draft.reviews.isLoading = false;
                draft.reviews.isError = true;
                draft.reviews.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_REVIEWS_CANCELLED:
                draft.reviews.isLoading = false;
                return draft;
            case ActionTypes.SET_REVIEWS_IS_LOADED:
                draft.reviews.isLoaded = action.isLoaded;
                return draft;
            case ActionTypes.SET_REVIEWS_HAS_MORE:
                draft.reviews.hasMore = action.hasMore;
                return draft;
            case ActionTypes.RESET_REVIEWS:
                draft.reviews.res = [];
                return draft;
            default:
                return draft;
        }
    });
}

export default activityReviewsPageReducer;
